export const DASHBOARD_APIS_DATA = {
  DASHBOARD_APIS_DATA_SET_SELECTED: "DASHBOARD_APIS_DATA_SET_SELECTED",
  DASHBOARD_APIS_DATA_CLEAR_SELECTED: "DASHBOARD_APIS_DATA_CLEAR_SELECTED",
};
